import {usePage} from '@inertiajs/vue3';
import {onMounted, watch} from 'vue';
import {FlashMessageData} from '@/scripts/types/generated';
import {Toast, useToast} from '@/components/ui/toast/use-toast';

const messages = ref<Toast[]>([]);

export function useFlashMessages() {
	onMounted(() => {
		const $page = usePage();
		const {toast} = useToast();

		const showMessages = (messages: (FlashMessageData | Toast)[]) => {
			if (messages.length === 0) {
				return;
			}

			for (const message of messages) {
				toast(message);
			}
		};

		showMessages($page.props.flashMessages);

		watch(() => $page.props.flashMessages, showMessages);
		watch(messages, (newMessages) => {
			showMessages(newMessages);
			messages.value = [];
		});
	});

	const addMessage = (message: Toast) => {
		messages.value.push(message);
	};

	return {addMessage};
}
